<template>
    <module-card
        v-bind="params"
        :loading="loading"
        :permissions="permissions"
        :roles="roles"
        :error="error"
        :errorText="errorText"
        :retryFunction="retryFunction"
        :segmentations="segmentations"
        @visibleChanged="$emit('visibleChanged', $event)"
    >
       <template slot="content">
            <div
                v-for="(item, i) in _items"
                class="legal-docs-card__item"
                :key="i"
            >
                <div class="legal-docs-card__item__title">
                    {{ docTypeEnumText[item.legalDocument.type].shortName }}
                </div>
                <div
                    :class="`legal-docs-card__item__icon ${
                        item.legalDocument.status === docTypeEnumValue.done
                            ? 'financial--color'
                            : ''
                    }`
                ">
                    <i class="bexsicon-check arrow" />
                </div>
            </div>
        </template>
        <template slot="actions">
            <v-btn
                class="slin-btn"
                @click="$router.push({
                    name: 'documents',
                    params: { type: 'legal' }
                })"
                :style="{ color: params.themeColor }"
            >
                <i class="bexsicon-docs-sm" />
                Ver todos documentos legais
            </v-btn>
        </template>
    </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card'
import { PROFILES, ROLES, UNIT, DOCS, SEGMENTATIONS } from '../../utils/constants'
import enums from '@/utils/enums'
export default {
    name: 'legal-docs-card',
    components: {
        ModuleCard
    },
    computed:{
        segmentations(){
          const product = this.$store.getters[UNIT.GET_SELECTED_PRODUCT]
          const hasDocs = this.$store.getters[DOCS.HAS_LEGAL_DOCS]
          if(product){
            if(!hasDocs){
              return null
            }

            const constructionStage = enums.constuctionStages[product.stage]
            switch(constructionStage){
              case 'launch':
                return null
                break;
              case 'inConstruction':
                return !this.$store.getters[DOCS.HAS_LEGAL_DOCS] ? null : [
                  SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                  SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                  SEGMENTATIONS.SFH__REHEARSE_STATUS,
                  SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                  SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE,
                ]
                break;
              case 'delivered':
                if(this.$store.getters[UNIT.GET_SELECTED].keyDeliveryDate){
                  return null
                }else{
                  return [
                    SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                    SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                    SEGMENTATIONS.SFH__REHEARSE_STATUS,
                    SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                    SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
                  ]
                }

                break;
              default:
                return []
            }
          }else{
            return null
          }
        },
                _items() {
            return this.items.slice(0, 3)
        }
    },
    data() {
        return {
            permissions: [PROFILES.ADMIN_PROFILE, PROFILES.ADMIN_BEXS_PROFILE, PROFILES.ADMIN_HR_PROFILE, PROFILES.HR_PROFILE],
            roles: []
        }
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        params: {
            type: Object,
            required: true,
        },
        docTypeEnumText: {
            type: Object,
            required: true,
        },
        docTypeEnumValue: {
            type: Object,
            required: true,
        },
        error: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        errorText: String,
        retryFunction: Function
    },
}
</script>
<style lang="scss" scoped>

.legal-docs-card {

    &__item {
        font-size: .9em;
        border-bottom: 1px solid rgb(240, 240, 240);
        padding: .5em;
        display: flex;

        &__title {
            flex: .5;
        }

        &__icon {
            text-align: right;
            flex: .5;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/LegalDocsCard.vue